import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { markdownLinkComponents, practiceUrlTransform } from '../../utils/practiceLinks';
import './panels.css';

const TOPIC_LABELS = {
  DM: 'Decision Making',
  VR: 'Verbal Reasoning',
  QR: 'Quantitative Reasoning',
  SJT: 'Situational Judgement',
  exam_tips: 'Exam Tips',
};

function SelfGuidedPanel({ topic, user, apiUrl, onStartPractice }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({ title: '', body: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setLoading(true);
    setEditing(false);
    axios
      .get(`${apiUrl}/content/self-guided/${topic}`)
      .then((r) => {
        setData(r.data);
        setForm({ title: r.data.title, body: r.data.body });
      })
      .finally(() => setLoading(false));
  }, [topic, apiUrl]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await axios.patch(`${apiUrl}/content/self-guided/${topic}`, form);
      setData(res.data);
      setEditing(false);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>Loading...
      </div>
    );
  }

  return (
    <div className="panel">
      {editing ? (
        <div className="content-edit-form">
          <input
            type="text"
            className="content-title-input"
            value={form.title}
            onChange={(e) => setForm((f) => ({ ...f, title: e.target.value }))}
            placeholder={TOPIC_LABELS[topic]}
          />
          <textarea
            className="content-body-textarea"
            value={form.body}
            onChange={(e) => setForm((f) => ({ ...f, body: e.target.value }))}
            rows={16}
            placeholder="Add study material... (Markdown supported: # Heading, **bold**, - bullet lists)"
          />
          <div className="content-edit-actions">
            <button className="btn btn-secondary" onClick={() => setEditing(false)} disabled={saving}>Cancel</button>
            <button className="btn btn-primary" onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
          </div>
        </div>
      ) : (
        <>
          <div className="panel-header-row">
            <h2>{data?.title || TOPIC_LABELS[topic]}</h2>
            {user.role === 'admin' && (
              <button className="btn btn-secondary" onClick={() => setEditing(true)}>Edit</button>
            )}
          </div>
          {data?.body ? (
            <div className="content-body markdown-body">
              <ReactMarkdown remarkPlugins={[remarkGfm]} urlTransform={practiceUrlTransform} components={markdownLinkComponents(onStartPractice)}>
                {data.body}
              </ReactMarkdown>
            </div>
          ) : (
            <p className="content-empty">Content for this module hasn't been added yet.</p>
          )}
        </>
      )}
    </div>
  );
}

export default SelfGuidedPanel;
